var _circle, _rect, _path, _path2, _path3, _rect2, _path4, _path5, _rect3, _path6, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle9, _circle10, _circle11, _circle12, _circle13, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseExpirationFall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 311,
    viewBox: "0 0 496 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 218.5,
    r: 77.5,
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 194.79,
    y: 154.817,
    width: 168.443,
    height: 115.006,
    rx: 2.32335,
    fill: "white",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270 209C273.333 210.167 281.4 211.8 287 209",
    stroke: "#9FA8BA",
    strokeWidth: 2.32335,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.853 198.293C263.853 203.426 259.693 207.587 254.56 207.587C249.427 207.587 245.266 203.426 245.266 198.293C245.266 193.161 249.427 189 254.56 189C259.693 189 263.853 193.161 263.853 198.293Z",
    fill: "#9FA8BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260 198.347C260 201.385 257.538 203.847 254.5 203.847C251.462 203.847 249 201.385 249 198.347C249 195.31 251.462 192.847 254.5 192.847C257.538 192.847 260 195.31 260 198.347Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 197.847,
    width: 21,
    height: 11,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M311.853 198.293C311.853 203.426 307.693 207.587 302.56 207.587C297.427 207.587 293.266 203.426 293.266 198.293C293.266 193.161 297.427 189 302.56 189C307.693 189 311.853 193.161 311.853 198.293Z",
    fill: "#9FA8BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308 198.347C308 201.385 305.538 203.847 302.5 203.847C299.462 203.847 297 201.385 297 198.347C297 195.31 299.462 192.847 302.5 192.847C305.538 192.847 308 195.31 308 198.347Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 197.847,
    width: 21,
    height: 11,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.79 157.141C194.79 155.858 195.831 154.817 197.114 154.817H360.91C362.193 154.817 363.234 155.858 363.234 157.141V167.596H194.79V157.141Z",
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 2.32335
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.407,
    cy: 198.38,
    r: 2.90419,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.778,
    cy: 198.38,
    r: 2.90419,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.599,
    cy: 201.865,
    r: 1.74251,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.97,
    cy: 200.704,
    r: 1.74251,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.246,
    cy: 204.769,
    r: 2.32335,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.455,
    cy: 204.769,
    r: 2.32335,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.617,
    cy: 76.6168,
    r: 11.6168,
    fill: "#F1F3F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 141C174.681 156.879 180.167 186.5 186 200L265 138C250.833 132.833 225 118.5 195.5 141Z",
    fill: "#8DB8AA",
    stroke: "#56957F",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187 227.5C207.8 217.5 246.5 163.5 267.5 138.5L162.5 216.5C160.5 216.5 146.5 223.5 127 230C151.8 240 177.333 232.5 187 227.5Z",
    fill: "#78AB9A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M333 264C343.8 268 340.833 279.667 338 285C317 272 242 275 218 275C237 254.5 319.5 259 333 264Z",
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M278 267.5V260H287.5V270.5L278 267.5Z",
    fill: "#DADEEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195 292C223.4 278.4 279.833 275.667 304.5 276C251 256 206.5 262.5 187 269.5C167.5 276.5 177.5 260 150.5 249.5C123.5 239 108 249.5 103.5 263.5C141.5 261 159.5 309 195 292Z",
    fill: "#F1F3F9",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5 261L304 276.5L316 277.5L318.5 261H307.5Z",
    fill: "#DADEEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 268.5L330.5 281.5L338 284.5C338.667 282.667 340.1 278.1 340.5 274.5C340.9 270.9 339.333 269 338.5 268.5Z",
    fill: "#DADEEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M275 267.5C273 270.667 269 277.1 269 277.5H255.5L263.5 265L275 267.5Z",
    fill: "#DADEEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 280V263.5H223.5L228 282.5L240.5 280Z",
    fill: "#DADEEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M207 287.5L206.5 265L188.5 269.5L195.5 291.5L207 287.5Z",
    fill: "#DADEEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166 293L176 270L162 255.5L148.5 282.5L166 293Z",
    fill: "#DADEEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130 269L136.5 245.5H123L112 251V264L130 269Z",
    fill: "#DADEEB"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 451.617,
    cy: 221.617,
    r: 11.6168,
    fill: "#F1F3F8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.617,
    cy: 11.6168,
    r: 11.6168,
    fill: "#F1F3F8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.5,
    cy: 83.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.5,
    cy: 62.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 203.5,
    r: 4.5,
    fill: "#F1F3F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M191 236.991C169.263 241.726 147.276 236.991 139 234.032L157.27 235.723L176.477 232.341L191 226V236.991Z",
    fill: "#56957F",
    stroke: "#56957F",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M390 114.359C411.5 136.859 404 205.859 365 217.859V157.859C365 155.649 363.209 153.859 361 153.859L256.5 153.859C302.5 95.4999 347.406 69.7831 390 114.359Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M365 219.5C404 207.5 411.5 138.5 390 116C347.406 71.4245 299.836 91.5495 223.5 194C205.358 218.348 178.555 244.52 128.291 231.6C126.303 231.089 126.416 228.311 128.413 227.835C186.5 213.99 182.292 194.617 273 135.041",
    stroke: "#56957F",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3053 153.383C37.0243 159.408 34.6858 163.61 33.3017 164.957C38.8906 169.238 39.1346 175.489 38.5581 178.08C38.5209 177.783 37.7146 176.631 34.7871 174.389C32.4719 179.892 28.3981 183.763 26.6507 185.011L24.7994 179.848L16.7117 182.481L16.8545 176.437L6.3577 169.467L15.1595 159.355L13.363 153.43L21.435 154.263C21.5146 153.699 21.736 151.871 21.9848 149.065C28.1482 151.218 31.2063 155.059 31.965 156.71C32.1744 156.781 33.1356 156.215 35.3053 153.383Z",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3515 163.375L14.476 168.281",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2571 156.736C29.2227 159.183 33.802 166.462 28.3946 176.004",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5367 159.143C21.2888 159.706 27.6117 161.841 30.887 165.876C29.784 169.394 26.0272 173.606 21.0896 175.55",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M477.918 97.4284C472.59 94.1317 471.489 89.4508 471.605 87.5224C464.591 88.1214 460.201 83.6645 458.882 81.3612C459.109 81.555 460.481 81.8642 464.156 81.5504C462.161 75.9227 462.566 70.3175 463.017 68.2184L467.863 70.7889L472.068 63.3954L476.033 67.9597L488.486 66.0437L488.79 79.447L494.107 82.6168L487.579 87.4374C487.9 87.9074 488.967 89.4079 490.673 91.6497C484.667 94.2089 479.82 93.4291 478.147 92.7192C477.944 92.8076 477.615 93.8731 477.918 97.4284Z",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M461.544 98.8264L483.284 72.3878",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M482.349 88.856C478.509 89.0441 470.221 86.7466 467.794 76.0517",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M486.435 81.8775C484.022 83.3147 477.91 85.9946 472.771 85.2168C471.217 81.8733 471.158 76.2297 473.499 71.4674",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M447.411 295.127C448.622 288.979 452.616 286.302 454.461 285.731C451.432 279.376 454.059 273.699 455.751 271.654C455.649 271.935 455.843 273.328 457.429 276.657C461.995 272.809 467.384 271.215 469.508 270.899L468.807 276.339L477.208 277.674L474.331 282.991L480.507 293.973L468.068 298.974L466.973 305.067L460.163 300.654C459.836 301.119 458.807 302.646 457.309 305.032C452.8 300.311 451.824 295.499 451.899 293.684C451.745 293.525 450.632 293.591 447.411 295.127Z",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M440.34 280.292L472.738 291.336",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M456.994 296.257C455.467 292.729 454.701 284.163 463.857 278.127",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M464.964 297.626C462.77 295.873 458.11 291.095 457.03 286.011C459.613 283.38 464.874 281.339 470.156 281.854",
    stroke: "#DADEEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseExpirationFall);
export default __webpack_public_path__ + "static/media/license_expiration_fall.369da291945f8971dc244417923cc8c3.svg";
export { ForwardRef as ReactComponent };